import { render, staticRenderFns } from "./SwappTasksExportDialog.vue?vue&type=template&id=48a7f128&scoped=true&"
import script from "./SwappTasksExportDialog.vue?vue&type=script&lang=js&"
export * from "./SwappTasksExportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7f128",
  null
  
)

export default component.exports